"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKERS = exports.MarkerUtil = exports.Markers = void 0;
class Markers extends Map {
    constructor(...args) {
        super(...args);
        Object.setPrototypeOf(this, new.target.prototype);
        this.normalize();
    }
    static createEmpty() {
        const markers = new Markers();
        return markers;
    }
    static fromPlain(plain) {
        const markers = new Markers(plain);
        return markers;
    }
    toPlain() {
        return [...this.entries()];
    }
    normalize() {
        for (const [, wordMarkers] of this.entries()) {
            MarkerUtil.sort(wordMarkers);
        }
    }
    get(uniqueName) {
        var _a;
        const markers = (_a = super.get(uniqueName)) !== null && _a !== void 0 ? _a : [];
        return markers;
    }
    toggle(uniqueName, marker) {
        const wordMarkers = [...this.get(uniqueName)];
        const index = wordMarkers.findIndex((existingMarker) => existingMarker === marker);
        if (index >= 0) {
            wordMarkers.splice(index, 1);
        }
        else {
            wordMarkers.push(marker);
        }
        if (wordMarkers.length > 0) {
            MarkerUtil.sort(wordMarkers);
            super.set(uniqueName, wordMarkers);
        }
        else {
            super.delete(uniqueName);
        }
    }
}
exports.Markers = Markers;
class MarkerUtil {
    static cast(value) {
        if (typeof value === "string") {
            const anyValue = value;
            const index = exports.MARKERS.indexOf(anyValue);
            if (index >= 0) {
                return exports.MARKERS[index];
            }
            else {
                return undefined;
            }
        }
        else if (typeof value === "number") {
            if (value >= 0 && value < exports.MARKERS.length) {
                return exports.MARKERS[value];
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    static sort(markers) {
        return markers.sort((firstMarker, secondMarker) => this.getIndex(firstMarker) - this.getIndex(secondMarker));
    }
    static getIndex(marker) {
        return exports.MARKERS.indexOf(marker);
    }
}
exports.MarkerUtil = MarkerUtil;
exports.MARKERS = ["circle", "square", "up", "diamond", "down", "cross", "heart", "pentagon", "hexagon", "trapezoid"];
